import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const FAQ = () => {
  const faqs = [{
    q: '¿En qué formato se entrega el material?',
    a: 'Todo el KIT y los bonus se entregan en formato digital (archivos PDF de alta calidad). Apenas confirmás la compra, el material se envía automáticamente al correo electrónico que ingreses antes de pagar. Desde ahí podés descargarlo, guardarlo en tus dispositivos o imprimirlo para usar en el consultorio.'
  }, {
    q: '¿Por cuánto tiempo tengo acceso al KIT?',
    a: 'El acceso es de por vida. Hacés un único pago y el material es tuyo para siempre, sin suscripciones ni pagos mensuales ocultos.'
  }, {
    q: '¿Sirve si recién empiezo a atender pacientes?',
    a: '¡Totalmente! Está diseñado justamente para darte la estructura y seguridad que suele faltar al inicio. Te guía paso a paso desde qué preguntar en la primera consulta hasta cómo planificar el alta.'
  }, {
    q: '¿Este KIT reemplaza una formación de posgrado en TCA?',
    a: 'No. Este material es una herramienta clínica práctica y complementaria. No reemplaza la formación formal, la supervisión profesional ni el criterio clínico individual, pero te brinda un marco de trabajo ordenado y aplicable.'
  }, {
    q: '¿Cuáles son los medios de pago disponibles?',
    a: 'Podés abonar de forma 100% segura a través de nuestra plataforma con tarjetas de crédito, débito o dinero en cuenta de MercadoPago (según disponibilidad en el checkout).'
  }, {
    q: '¿Tienen garantía?',
    a: 'Sí, tenés 7 días de garantía de satisfacción. Si sentís que el material no aporta valor a tu práctica clínica, te devolvemos el 100% de tu dinero sin hacer preguntas.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-white" data-id="element-40">
      <div className="max-w-3xl mx-auto" data-id="element-41">
        <h2 className="font-serif text-3xl font-bold text-center text-brand-teal-dark mb-12" data-id="element-42">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-43">
          {faqs.map((faq, idx) => <div key={idx} className="border border-gray-200 rounded-xl overflow-hidden bg-brand-cream/30" data-id="element-44">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus-visible:bg-brand-cream" data-id="element-45">
                <span className="font-bold text-brand-teal-dark pr-4" data-id="element-46">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 flex-shrink-0 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-47" />
              </button>

              <AnimatePresence data-id="element-48">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-49">
                    <div className="p-6 pt-0 text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-50">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};